import React from 'react'
import ReactDOM from 'react-dom'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import PrivateRoute from 'app/universal/route/PrivateRoute'
import withAlphaAccess from 'app/universal/route/withAlphaAccess'

import MissingInformations from 'app/orderTool/pages/missingInformations/MissingInformations';
import ManageOrders from 'app/orderTool/pages/manageOrders/ManageOrders';
import Agenda from 'app/deliveryTool/pages/agenda/Agenda.js';
import PipelineB2b from 'app/orderTool/pages/pipelineB2b/PipelineB2b';
import PipelineSav from 'app/orderTool/pages/pipelineSav/PipelineSav';
import RecouvrementImpayes from 'app/orderTool/pages/recouvrement/RecouvrementImpayes';
import RotationsForfaits from 'app/orderTool/pages/rotationsForfaits/RotationsForfaits';
import RapprochementBancaire from 'app/orderTool/pages/banque/RapprochementBancaire';
import DashboardData from 'app/orderTool/pages/dashboard/DashboardData';
import Planning from 'app/deliveryTool/pages/planning/Planning';
import Itineraires from 'app/deliveryTool/pages/itineraire/Itineraires';
import PrintPlanning from 'app/deliveryTool/pages/printPlanning/PrintPlanning';
import PublicPlanning from 'app/deliveryTool/pages/publicPlanning/PublicPlanning';
import CardProdMultipole from 'app/orderTool/pages/cardProdMultipole/CardProdMultipole';
import CardProdMultipoleV2 from 'app/orderTool/pages/cardProdMultipoleV2/CardProdMultipoleV2';
import Anticipation from 'app/orderTool/pages/anticipation/Anticipation';
import MultiOrders from 'app/orderTool/pages/multiOrders/MultiOrders';
import MultiFormats from 'app/orderTool/pages/multiOrders/MultiFormats';
import TenderCatalogItemsManager from 'app/orderTool/pages/tenderCatalog/TenderCatalogItemsManager';
import TenderCatalogList from 'app/orderTool/pages/tenderCatalog/TenderCatalogList';
import TenderCatalogRangeManager from 'app/orderTool/pages/tenderCatalog/TenderCatalogRangeManager';
import PrestationRoadSheet from 'app/orderTool/pages/prestationRoadSheet/PrestationRoadSheet';
import PrintMenu from 'app/orderTool/pages/printMenu/PrintMenu';
import ClientPlanning from 'app/orderTool/pages/clientPlanning/ClientPlanning';
import LmvpPlateaux from 'app/orderTool/pages/lmvpPlateaux/LmvpPlateaux';
import NotFound404 from 'app/universal/404/NotFound404';

// Companion livreur
import Roadmaps from 'app/companion/pages/roadmaps/Roadmaps.js';
import DeliverySheet from 'app/companion/pages/delivery/detail/DeliverySheet.js';
import DeliveryMaterial from 'app/companion/pages/delivery/materials/DeliveryMaterial.js';
import DeliveryComment from 'app/companion/pages/delivery/comment/DeliveryComment.js';

// Fin companion livreur

 // eslint-disable-next-line
import Global from 'app/universal/styles/Global';
import * as serviceWorker from './serviceWorker';
import WindowDimensionsProvider from 'app/universal/utils/WindowDimensionsProvider'
import ApiAuthProvider from 'app/universal/context/ApiAuthProvider'
import ErrorBoundary from 'app/universal/errors/ErrorBoundary'
import { Provider } from 'react-redux';
import { store, persistor } from 'state/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { register as registerServiceWorker } from './serviceWorker';
import swal from 'sweetalert';
import RoadmapTable from 'app/deliveryTool/pages/roadmapTable/RoadmapTable';
import ItinerairesB2C from 'app/roadmapB2C/ItinerairesB2C';

// Reinitialisation du store au déploiement
const deployVer = process.env.REACT_APP_VERSION;
const curVersion = localStorage.getItem('version');
if(curVersion === 'undefined' || curVersion === null || curVersion !== deployVer){
  localStorage.setItem('version', deployVer);
  persistStore(store).purge();
  document.location.reload();
}

console.log('curVersion', curVersion, 'deployVer', deployVer);

// Onglets B2B alpha : accès par utilisateur via admin_user.alpha_features
// (fiche admin Sonata, exposé par /api/me.json) — hors prod tout reste ouvert.
// ⚠️ garder les slugs synchrones avec DesktopMenu.js et AdminUser::ALPHA_FEATURES.

const routing = (
  <WindowDimensionsProvider>
    <ErrorBoundary>
      <Provider store={store}>
        <ApiAuthProvider>
          <Router>
            <Switch>
              <PrivateRoute exact path="/informations-devis-manquantes" component={MissingInformations} roles={['admin']} />
              <PrivateRoute path="/planning" component={Planning} roles={['admin']} />
              <PrivateRoute exact path="/itineraires/" component={Itineraires} roles={['admin']} />
              <PrivateRoute path="/itineraires/:id" component={Itineraires} roles={['admin']} />
              <PrivateRoute path="/impression-planning" component={PrintPlanning} roles={['admin']} />
              <Route path="/impression-planning-public" component={PublicPlanning} roles={['admin']}/>
              <PrivateRoute path="/agenda" component={Agenda} roles={['admin']} />
              {/* Onglets B2B alpha : routes toujours déclarées, l'accès est
                  contrôlé par withAlphaAccess (URL directe sans accès → retour
                  à l'accueil). */}
              <PrivateRoute path="/pipeline-b2b" component={PipelineB2b} roles={['pro']} />
              <PrivateRoute path="/pipeline-sav" component={PipelineSav} roles={['pro']} />
              <PrivateRoute path="/recouvrement-impayes" component={RecouvrementImpayes} roles={['admin']} />
              <PrivateRoute path="/rotations-forfaits" component={withAlphaAccess('rotation_carte', RotationsForfaits)} roles={['admin']} />
              <PrivateRoute path="/rapprochement-bancaire" component={withAlphaAccess('rapprochement_bancaire', RapprochementBancaire)} roles={['finance']} />
              <PrivateRoute path="/dashboard-data" component={withAlphaAccess('dashboard_data', DashboardData)} roles={['stats']} />
              <PrivateRoute path="/fiche-production-multipole" component={CardProdMultipole} roles={['admin']} />
              <PrivateRoute path="/fiche-production-multipole-v2" component={CardProdMultipoleV2} roles={['admin']} />
              <PrivateRoute path="/anticipation" component={Anticipation} roles={['admin']} />
              <PrivateRoute exact path="/" component={ManageOrders} roles={['admin']}/>
              <PersistGate loading={null} persistor={persistor}>
                <PrivateRoute exact path="/informations-devis-manquantes" component={MissingInformations} roles={['admin']} />
                <PrivateRoute path="/commande" component={MultiOrders} roles={['admin']} />
                <PrivateRoute path="/dej_multi_format" component={MultiFormats} roles={['admin']} />
                <PrivateRoute path="/appel_offre" component={TenderCatalogList} roles={['admin']} />
                <PrivateRoute path="/appel_offre_prix/:tenderId/prix" component={TenderCatalogItemsManager} roles={['admin']} />
                <PrivateRoute path="/appel_offre_prix/:tenderId/palier" component={TenderCatalogRangeManager} roles={['admin']} />
                <PrivateRoute path="/feuille-de-route/:orderId" component={PrestationRoadSheet} roles={['admin']} />
                <PrivateRoute path="/menu-a-imprimer/:orderId" component={PrintMenu} roles={['admin']} />
                <PrivateRoute path="/planning-client/:orderId" component={withAlphaAccess('planning_client', ClientPlanning)} roles={['admin']} />
                <PrivateRoute path="/lmvp-plateaux" component={LmvpPlateaux} roles={['admin']} />
                {/* Companion livreur */}
                <PrivateRoute exact path="/companion" component={Roadmaps} roles={['companion']} />
                <PrivateRoute path="/companion/tournee/:roadmapId/:deliveryId/detail" component={DeliverySheet} roles={['companion']} />
                <PrivateRoute path="/companion/tournee/:roadmapId/:deliveryId/materiel" component={DeliveryMaterial} roles={['companion']} />
                <PrivateRoute path="/companion/tournee/:roadmapId/:deliveryId/commentaire" component={DeliveryComment} roles={['companion']} />
                <PrivateRoute path="/tableau-des-tournees" component={RoadmapTable} roles={['admin']} />
                <PrivateRoute path="/itineraires-b2c" component={ItinerairesB2C} roles={['admin', 'gestionnaire', 'b2c_livreur']} />
              </PersistGate>
              <Route component={NotFound404} />
            </Switch>
          </Router>
        </ApiAuthProvider>
      </Provider>
    </ErrorBoundary>
  </WindowDimensionsProvider>
)

ReactDOM.render(routing, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (module.hot) {
  module.hot.accept();
}